import { Injectable, inject } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { LendingTypeService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class CriteriaNavigateService {
  private readonly router = inject(Router);
  private readonly lendingTypeService = inject(LendingTypeService);

  public criteriaV2Enabled = true;

  public navigateHome() {
    this.router.navigateByUrl('/ignite/criteriaV2/landing');
  }

  public navigateRootPage(page: string): void {
    this.router.navigateByUrl(`/ignite/criteriaV2/landing/${page}`);
  }

  public navigate(url: string, navigationOptions: NavigationExtras | null = null) {
    let defaultNavigationExtras: NavigationExtras = {};

    if (navigationOptions) {
      defaultNavigationExtras = {
        ...defaultNavigationExtras,
        ...navigationOptions,
      };

      if (navigationOptions.queryParams && Object.values(navigationOptions.queryParams).filter(v => v).length === 0) {
        defaultNavigationExtras.queryParams = {};
      }
    }

    const urlTree = this.router.createUrlTree(
      [
        this.lendingTypeService.lendingType
          ? `/ignite/criteriaV2/landing/${this.lendingTypeService.lendingType.id}/${url}`
          : `/ignite/criteriaV2/landing/${url}`,
      ],
      defaultNavigationExtras,
    );
    this.router.navigateByUrl(urlTree, defaultNavigationExtras);
  }
}
